// extracted by mini-css-extract-plugin
export default {"container":"_1bcb8571","arrow":"_ede7c16f"};